// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2wgjN","inner":"Form_inner__1U9cI","range":"Form_range__ljCkd","name":"Form_name__1ma3a","actions":"Form_actions__3yPrM"};